import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="site-footer">
      <div className="footer-container">
        <div className="footer-content">
          {/* Left Section - Logo and Social */}
          <div className="footer-left">
            <div className="footer-logo">
              {/* Replace with your actual logo image or SVG */}
              <img src="/assets/images/Vector-Logo.webp" alt="Samra's Pins Logo" />
            </div>
            <p className="footer-tagline">Your daily dose of magic</p>
            
            <div className="footer-social">
              <a href="https://www.instagram.com/samraspins/" target="_blank" rel="noopener noreferrer" aria-label="Follow us on Instagram" className="footer-social-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="31.4" height="31.4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <rect x="2" y="2" width="20" height="20" rx="5" ry="5"/>
                  <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"/>
                  <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"/>
                </svg>
              </a>
              <a href="https://www.facebook.com/share/g/15mZ8tkfxp/?mibextid=wwXIfr" target="_blank" rel="noopener noreferrer" aria-label="Find us on Facebook" className="footer-social-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="34.64" height="34.64" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/>
                </svg>
              </a>
              {/* tiktok */}
              <a href="https://www.tiktok.com/@samraspins" target="_blank" rel="noopener noreferrer" aria-label="Follow us on TikTok" className="footer-social-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="34.64" height="34.64" viewBox="0 0 24 24" fill="none" id="tiktok" data-name="Line Color" strokeWidth="2" class="icon line-color">
                  <path id="primary" d="M21,7H20a4,4,0,0,1-4-4H12V14.5a2.5,2.5,0,1,1-4-2V8.18a6.5,6.5,0,1,0,8,6.32V9.92A8,8,0,0,0,20,11h1Z"></path>
                </svg>
              </a>
            </div>
          </div>
          
          {/* Right Section - Links */}
          <div className="footer-right">
            {/* Search Column */}
            <div className="footer-column">
              <h3>Search</h3>
              <ul className="footer-links">
                <li><Link to="/about" onClick={() => window.scrollTo(0, 0)}>About Us</Link></li>
                <li><Link to="/category/all" onClick={() => window.scrollTo(0, 0)}>Products</Link></li>
                {/* <li><Link to="/vault" onClick={() => window.scrollTo(0, 0)}>Vault</Link></li> */}
                <li><Link to="/subscriptions/mystery-pins" onClick={() => window.scrollTo(0, 0)}>Mystery Pins</Link></li>
                {/* <li><Link to="/subscriptions/monthly-pins" onClick={() => window.scrollTo(0, 0)}>Monthly Pins</Link></li> */}
              </ul>
            </div>
            
            {/* Contact Column */}
            <div className="footer-column">
              <h3>Contact</h3>
              <ul className="footer-links">
                <li><Link to="/request-item" onClick={() => window.scrollTo(0, 0)}>Request An Item</Link></li>
                <li><Link to="/faq" onClick={() => window.scrollTo(0, 0)}>FAQs</Link></li>
                <li><Link to="/general-policies" onClick={() => window.scrollTo(0, 0)}>General Policies</Link></li>
                <li><Link to="/subscription-policies" onClick={() => window.scrollTo(0, 0)}>Subscription Policies</Link></li>
                <li><Link to="/contact" onClick={() => window.scrollTo(0, 0)}>Contact Us</Link></li>
              </ul>
            </div>
          </div>
        </div>
        
        {/* Copyright */}
        <div className="footer-copyright">
          <p>{currentYear} all Right Reserved Term of use Samra's Pins</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;